import React from 'react';
import { IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useDetailNavigation } from './hooks/useDetailNavigation';

export const NavigationButtons = React.memo(({
cardId,
cardsOfSameWorkflowStepId,
}) => {
  const { currentCardIndex, handleNext, handlePrevious } = useDetailNavigation({
    cardId,
    cardsOfSameWorkflowStepId,
  });
  
  return (
    <>
      {currentCardIndex > 0 && (
        <IconButton
          className="card-detail-prev-icon"
          onClick={handlePrevious}
          sx={{
            position: 'absolute',
            left: 16,
            bottom: '50%',
            padding: '12px',
            backgroundColor: '#DCDCDC',
            borderRadius: '50%',
            zIndex: 1000,
            transition: 'all 0.3s',
            '&:hover': {
              transform: 'scale(1.1)',
            },
          }}
        >
          <ArrowBackIosNewIcon />
        </IconButton>
      )}
      {currentCardIndex < cardsOfSameWorkflowStepId?.length - 1 && (
        <IconButton
          className="card-detail-next-icon"
          onClick={handleNext}
          sx={{
            position: 'absolute',
            right: 16,
            bottom: '50%',
            padding: '12px',
            backgroundColor: '#DCDCDC',
            borderRadius: '50%',
            zIndex: 1000,
            transition: 'all 0.3s',
            '&:hover': {
              transform: 'scale(1.1)',
            },
          }}
        >
          <ArrowForwardIosIcon />
        </IconButton>
      )}
    </>
  );
});
